import { IconButton, SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";

interface Props {
  Icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & {
    muiName: string;
  };
}

const FooterIcon = ({ Icon }: Props) => {
  return (
    <IconButton
      sx={{ border: "2px solid #00000014", height: "50px", width: "50px" }}
    >
      <Icon sx={{ color: "#fff", fontSize: "20px" }} />
    </IconButton>
  );
};

export default FooterIcon;
